module.exports = __webpack_public_path__ + "static/media/20180825_143950.2b9361d2.jpg";